import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractCancellationReasonCreateForm from "./create";
import ContractCancellationReasonEditForm from "./edit";
import {
  deleteCancellationReason,
  getCancellationReasonDetails,
  getCancellationReasons,
} from "src/store/contract-cancellation-reason/saga";
import {
  CancellationReasonDetailDto,
  CancellationReasonDto,
} from "src/store/contract-cancellation-reason/type";
const ContractCancellationReasonsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<CancellationReasonDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<CancellationReasonDetailDto>();
  const columns = [
    {
      text: t("Contract.CancellationReason.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.CancellationReason.PageTitle")}
        metaTag={t("Contract.CancellationReason.MetaTag")}
        gridProps={{
          addTitle: t("Contract.CancellationReason.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getCancellationReasons,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getCancellationReasonDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: any) =>
              t("Contract.CancellationReason.DeleteQA", {
                name: data.Name,
              }),
            action: deleteCancellationReason,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <ContractCancellationReasonCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getCancellationReasons,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractCancellationReasonEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getCancellationReasons,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractCancellationReasonsPage;
